//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getPaymentTransactionService } from "./paymentTransactionApi";

export default function usePaymentTransactionList() {
  const params = useParams();
  const scope = undefined;
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "payment-transactions/"
      : ""
  }`;
  const service = getPaymentTransactionService();

  return { ...service, params, scope, editUrl };
}
